import { Component, Input, ChangeDetectionStrategy } from "@angular/core"
import { COMMON_IMPORTS } from "../common-imports"
import { getIds } from "@app/helpers"
import { ApiService } from "@app/services/api.service"
import { LangService } from "@app/services/lang.service"
import { ModalService } from "@app/services/modal.service"
import { StoreService } from "@app/services/store.service"
import { ReportsComponent } from "@app/reports/reports.component"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { ModalWrapComponent } from "@app/modal-wrap/modal-wrap.component"
import { MeetingRequestsComponent } from "@app/meeting-requests/meeting-requests.component"
import { InvitePartnerComponent } from "@app/invite-partner/invite-partner.component"
import { PatientFieldTblComponent } from "@app/patient-field-tbl/patient-field-tbl.component"
import { NewUserComponent } from "@app/new-user/new-user.component"
import { SendUsersEmailComponent } from "@app/send-users-email/send-users-email.component"
import { InsertPatientFormComponent } from "@app/insert-patient-form/insert-patient-form.component"
import { GenTableDisplayComponent } from "@app/gen-table-display/gen-table-display.component"
import { TableNameDisplayPipe } from "@app/utils/table-name-display.pipe"

@Component({
	selector: "app-gen-table-header-btn",
	imports: [
		COMMON_IMPORTS,
		ReportsComponent,
		LangValPipe,
		ModalWrapComponent,
		MeetingRequestsComponent,
		InvitePartnerComponent,
		PatientFieldTblComponent,
		NewUserComponent,
		SendUsersEmailComponent,
		InsertPatientFormComponent,
		GenTableDisplayComponent,
		TableNameDisplayPipe,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		@if (btn?.textOnly) {
			<button
				class="btn btn-primary"
				(click)="open()"
			>
				{{ btn.hoverLang | langVal }}
			</button>
		} @else {
			<button
				class="btn btn-icon"
				[titleLang]="btn.hoverLang"
				(click)="open()"
				[icon]="btn.icon"
			></button>
		}
		@switch (modalProps?.name) {
			@case ("reports") {
				<app-reports
					isModalMode
					(onClose)="modalProps = null"
					[report_name]="modalProps.report_name"
				/>
			}
			@case ("meeting-requests") {
				<app-modal-wrap
					(onClose)="modalProps = null"
					hasExit
					title="meeting_requests_list"
				>
					<app-meeting-requests (onClose)="modalProps = null" />
				</app-modal-wrap>
			}
			@case ("invite-partner") {
				<app-modal-wrap
					(onClose)="modalProps = null"
					title="invite_partner"
					modalWrapperClass="modal-small-width"
				>
					<app-invite-partner (onClose)="modalProps = null" />
				</app-modal-wrap>
			}
			@case ("patient-field-tbl") {
				<app-modal-wrap
					(onClose)="modalProps = null"
					title="patientfields"
					modalWrapperClass="modal-wide"
				>
					<app-patient-field-tbl (onClose)="modalProps = null" />
				</app-modal-wrap>
			}
			@case ("new-user") {
				<app-modal-wrap
					(onClose)="modalProps = null"
					title="create_potential_user"
				>
					<app-new-user (onClose)="modalProps = null" />
				</app-modal-wrap>
			}
			@case ("send-users-email") {
				<app-modal-wrap
					(onClose)="modalProps = null"
					title="send_users_email"
				>
					<app-send-users-email
						(onClose)="modalProps = null"
						[checkedItems]="checkedRows"
					/>
				</app-modal-wrap>
			}
			@case ("insert-patient-form") {
				<app-modal-wrap
					(onClose)="modalProps = null"
					title="insert_patient_form"
					modalWrapperClass="modal-800"
				>
					<app-insert-patient-form
						(onClose)="modalProps = null"
						hasUpdate
					/>
				</app-modal-wrap>
			}
			@case ("gen-table-display") {
				<app-modal-wrap
					(onClose)="modalProps = null"
					[title]="modalProps.tableName | tableNameDisplay"
					[modalWrapperClass]="modalProps.modalWidth || 'modal-wide'"
				>
					<app-gen-table-display
						(onClose)="modalProps = null"
						[tableName]="modalProps.tableName"
						[isPagi]="modalProps.isPagi"
					/>
				</app-modal-wrap>
			}
		}
	`,
})
export class GenTableHeaderBtnComponent {
	@Input() btn: any
	@Input() checkedRows: any[] = []
	modalProps: any = null

	constructor(
		public lang: LangService,
		public apiService: ApiService,
		public store: StoreService,
		public modalService: ModalService
	) {}

	open() {
		const { fieldsToUpdate, modal } = this.btn
		switch (modal) {
			case "reports": {
				this.modalProps = {
					name: modal,
					report_name: fieldsToUpdate.report_name,
				}
				return
			}
			case "patient-field-tbl":
			case "invite-partner":
			case "send-users-email":
			case "new-user":
			case "insert-patient-form":
			case "meeting-requests": {
				this.modalProps = { name: modal }
				return
			}
			case "gen-table-display": {
				this.modalProps = {
					name: modal,
					tableName: fieldsToUpdate.tableName,
					isPagi: fieldsToUpdate.isPagi,
					modalWidth: fieldsToUpdate.modalWidth,
				}
				return
			}
		}
	}
}
